module.exports = __webpack_public_path__ + "img/MapThumb_Acropolis.8c7f6a73.webp";